export default __webpack_public_path__ + "static/media/header-more.4b45a0b3.svg";